<table mat-table #blfsTable [dataSource]="datasource">
    <!-- (change)="onChange($event)"-->
    <ng-container matColumnDef="lineKey">
        <th mat-header-cell *matHeaderCellDef>Touche</th>
        <td mat-cell *matCellDef="let element">Touche ligne {{ element.lineKey }}</td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let element">
            <div class="small edit-cell">
                <mat-form-field appearance="outline">
                    <mat-select [(value)]="element.type" [(ngModel)]="element.type" (selectionChange)="onTypeChange(element)">
                        @for (blfType of blfsTypes(); track blfType.type) {
                        <mat-option [value]="blfType.type">{{ blfType.typeName }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>Valeur</th>
        <td mat-cell *matCellDef="let element">
            <div class="small edit-cell">
                <mat-form-field appearance="outline">
                    <input matInput [value]="element.value" [(ngModel)]="element.value" />
                </mat-form-field>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef>Etiquette</th>
        <td mat-cell *matCellDef="let element">
            <div class="small edit-cell">
                <mat-form-field appearance="outline">
                    <input matInput [value]="element.label" [(ngModel)]="element.label" />
                </mat-form-field>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="lineEntry">
        <th mat-header-cell *matHeaderCellDef>Ligne</th>
        <td mat-cell *matCellDef="let element">
            <!-- Ligne {{ element.lineEntry }} -->
            <!-- <div class="small">
                <mat-form-field appearance="outline">
                    <input matInput [value]="element.lineEntry" [(ngModel)]="element.lineEntry" />
                </mat-form-field>
            </div> -->
            <div class="small edit-cell">
                <mat-form-field appearance="outline">
                    <mat-select [(value)]="element.lineEntry" [(ngModel)]="element.lineEntry">
                        <mat-option [value]="0">N/D</mat-option>
                        <mat-option [value]="1">Ligne 1</mat-option>
                        <mat-option [value]="2">Ligne 2</mat-option>
                        <mat-option [value]="3">Ligne 3</mat-option>
                        <mat-option [value]="4">Ligne 4</mat-option>
                        <mat-option [value]="5">Ligne 5</mat-option>
                        <mat-option [value]="6">Ligne 6</mat-option>
                        <mat-option [value]="7">Ligne 7</mat-option>
                        <mat-option [value]="8">Ligne 8</mat-option>
                        <mat-option [value]="9">Ligne 9</mat-option>
                        <mat-option [value]="10">Ligne 10</mat-option>
                        <mat-option [value]="11">Ligne 11</mat-option>
                        <mat-option [value]="12">Ligne 15</mat-option>
                        <mat-option [value]="13">Ligne 13</mat-option>
                        <mat-option [value]="14">Ligne 14</mat-option>
                        <mat-option [value]="15">Ligne 15</mat-option>
                        <mat-option [value]="16">Ligne 16</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="extension">
        <th mat-header-cell *matHeaderCellDef>Extension</th>
        <td mat-cell *matCellDef="let element">{{ element.value }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
